import { Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ReactComponent from '@/components/ReactComponent';
import { action, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { ContentPasteGo } from '@mui/icons-material';
import ModalRelatorioLocalDiferenteOrgaoJudicante from './Relatorios/ModalRelatorioLocalDiferenteOrgaoJudicante';

const RELATORIO_LOCAL_DIFERENTE_ORGAO_JUDICANTE = 'localDiferenteOrgaoJudicante';

class ExportarRelatoriosListaProcessos extends ReactComponent {
    cursor = 'pointer';
    cpfSignatario;
    anchorElExportarRelatorios = null;
    openMenuExportarRelatorios = Boolean(this.anchorElExportarRelatorios);

    openRelatorio = { [RELATORIO_LOCAL_DIFERENTE_ORGAO_JUDICANTE]: false };

    constructor(props) {
        super(props);

        makeObservable(this, {
            cursor: observable,
            cpfSignatario: observable,
            anchorElExportarRelatorios: observable,
            openMenuExportarRelatorios: observable,
            openRelatorio: observable,
            handleClickMenu: action,
            handleCloseMenu: action,
            handleOpenRelatorio: action,
            handleCloseRelatorio: action
        });
    }

    handleClickMenu = (event) => {
        this.anchorElExportarRelatorios = event.currentTarget;
        this.openMenuExportarRelatorios = true;
    };

    handleCloseMenu = () => {
        this.anchorElExportarRelatorios = null;
        this.openMenuExportarRelatorios = false;
    };

    handleOpenRelatorio = (relatorio) => {
        this.openMenuExportarRelatorios = false;
        this.openRelatorio[relatorio] = true;
    };

    handleCloseRelatorio = (relatorio) => {
        this.openRelatorio[relatorio] = false;
    };

    render() {
        const menuId = 'exportar-relatorios';

        return (
            <>
                <Tooltip title="Relatórios dos processos da sessão">
                    <IconButton
                        data-testid="abrirMenuExportarRelatorios"
                        id="iconeExportarRelatorios"
                        aria-label="Relatórios dos processos da sessão"
                        sx={{ p: 0, ml: 1, color: 'white' }}
                        onClick={this.handleClickMenu}
                    >
                        <ContentPasteGo />
                    </IconButton>
                </Tooltip>
                <Menu
                    id={menuId}
                    anchorEl={this.anchorElExportarRelatorios}
                    open={this.openMenuExportarRelatorios}
                    onClose={this.handleCloseMenu}
                    transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    sx={{ mt: 1 }}
                >
                    <MenuItem
                        onClick={() => this.handleOpenRelatorio(RELATORIO_LOCAL_DIFERENTE_ORGAO_JUDICANTE)}
                        sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                    >
                        <Typography>Processos em local diferente do órgão judicante</Typography>
                    </MenuItem>
                </Menu>

                {!!this.openRelatorio[RELATORIO_LOCAL_DIFERENTE_ORGAO_JUDICANTE] && (
                    <ModalRelatorioLocalDiferenteOrgaoJudicante
                        openModalImpressao={true}
                        onCloseModalImpressao={() =>
                            this.handleCloseRelatorio(RELATORIO_LOCAL_DIFERENTE_ORGAO_JUDICANTE)
                        }
                    />
                )}
            </>
        );
    }
}

export default inject('stores')(observer(ExportarRelatoriosListaProcessos));
